import { defineStore } from 'pinia';
import { actions, state } from '@/stores/methods';


export const useFanpagesStore = defineStore('fanpage', {
  state: state,
  actions: actions,
  getters: {
    getByFanpageId: (state) => {
      return (fanpageId) => state.collection.find(f => f.attributes['fanpage-id'] === fanpageId);
    },
    getByFanpageInstagramAccountId: (state) => {
      return (accountId) => state.collection.find((f) => {
        if (f.attributes['instagram-business-account']) {
          return f.attributes['instagram-business-account']['data']['attributes']['account-id'] === accountId;
        }
        return false;
      });
    },
  },
});
